var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.detailsFile
        ? _c(
            "b-modal",
            {
              ref: "modal-action-" + _vm.action,
              attrs: {
                id: "modal-action-" + _vm.action,
                title: _vm.title + " documento",
                "ok-title": _vm.title,
                "cancel-title": "Cancelar",
                "no-close-on-backdrop": "",
                size: "lg",
                centered: ""
              },
              on: { ok: _vm.commitAction, cancel: _vm.cancelProcess }
            },
            [
              _c("div", { staticClass: "-mt-2" }, [
                _c(
                  "form",
                  {
                    staticClass: "mt-4",
                    attrs: { "data-vv-scope": "sign-document" }
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-6 mt-3" },
                        [
                          _c("label", [_vm._v("Fecha")]),
                          _c("b-form-datepicker", {
                            staticClass: "w-100",
                            attrs: {
                              min: _vm.min,
                              id: "example-datepicker",
                              "label-help":
                                "Puede usar las flechas del teclado y espacio"
                            },
                            model: {
                              value: _vm.manageDate,
                              callback: function($$v) {
                                _vm.manageDate = $$v
                              },
                              expression: "manageDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              type: "number",
                              label: "Código OTP",
                              maxlength: "6",
                              name: "otp",
                              danger: _vm.errors.has("sign-document.otp"),
                              "danger-text": _vm.errors.first(
                                "sign-document.otp"
                              )
                            },
                            model: {
                              value: _vm.otpCode,
                              callback: function($$v) {
                                _vm.otpCode = $$v
                              },
                              expression: "otpCode"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "numerateModal",
          attrs: {
            "title-class": "font-weight-bold text-success",
            centered: "",
            size: "sm",
            "no-close-on-backdrop": "",
            title: "Genial!",
            id: "numerateModal",
            "hide-header-close": ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                return [
                  _c(
                    "div",
                    { staticClass: "w-100" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "float-right",
                          attrs: { variant: "success" },
                          on: {
                            click: function($event) {
                              ok(_vm.$router.back())
                            }
                          }
                        },
                        [_vm._v(" Ok ")]
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [_c("h5", [_vm._v("Se ha tramitado el documento exitosamente")])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }